import React from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight, Sparkles } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

export default function QuotaExceededModal({ open, onOpenChange, quota }) {
  const title = quota?.reason === "monthly_limit_reached"
    ? "Limite mensile raggiunto"
    : quota?.reason === "subscription_expired"
      ? "Abbonamento scaduto"
      : "Hai finito le analisi gratuite";

  const description = quota?.reason === "monthly_limit_reached"
    ? "Hai utilizzato tutte le analisi del tuo piano Basic per questo mese. Passa a Pro per analisi illimitate o attendi il rinnovo."
    : quota?.reason === "subscription_expired"
      ? "Il tuo abbonamento è scaduto. Riattivalo in un clic per continuare a usare AI TricoProtocol."
      : "Hai usato tutte le 5 analisi gratuite del tuo account. Passa a Basic o Pro per continuare.";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="quota-exceeded-modal">
        <DialogHeader>
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#C5A059] to-[#B38F4E] flex items-center justify-center mb-2">
            <Crown className="w-6 h-6 text-white" />
          </div>
          <DialogTitle className="font-serif-display text-3xl text-[#1A1A1A]">
            {title}
          </DialogTitle>
        </DialogHeader>

        <p className="text-[#737373] leading-relaxed pt-1">
          {description}
        </p>

        <div className="rounded-xl bg-[#FAFAFA] border border-[#E5E5E0] p-4 flex items-start gap-3 mt-2">
          <Sparkles className="w-4 h-4 text-[#C5A059] shrink-0 mt-1" />
          <div className="text-sm text-[#1A1A1A] leading-relaxed">
            <span className="font-semibold">Consigliato: Pro</span> — analisi illimitate a <span className="font-semibold">€59/mese</span>. Cancella quando vuoi.
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-3">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="h-11 px-5 rounded-xl border border-[#E5E5E0] text-[#737373] hover:border-[#C5A059] hover:text-[#1A1A1A] font-medium transition-all"
            data-testid="quota-modal-dismiss"
          >
            Più tardi
          </button>
          <Link
            to="/piani"
            onClick={() => onOpenChange(false)}
            className="h-11 px-5 rounded-xl bg-[#1A1A1A] hover:bg-[#C5A059] text-white font-medium transition-all inline-flex items-center gap-2"
            data-testid="quota-modal-upgrade"
          >
            Passa a Pro
            <ArrowRight className="w-4 h-4" />
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
